import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/nightOwl";
import { Pre, Line, LineNo, LineContent } from "./styles";

// JS Sample Code
const python = `import http.client
import json

conn = http.client.HTTPSConnection("baseUrl")
payload = json.dumps({
  "Email": "extuser@ext.com",
  "Password": "extuserpass"
})
headers = {
  'Content-Type': 'application/json'
}
conn.request("POST", "/API/authentication/login", payload, headers)
res = conn.getresponse()
data = res.read()
print(data.decode("utf-8"))
`;

function HTTPCRC() {
  return (
    <Highlight
      {...defaultProps}
      theme={theme}
      code={python}
      language="javascript"
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <Line key={i} {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>
              <LineContent>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </LineContent>
            </Line>
          ))}
        </Pre>
      )}
    </Highlight>
  );
}
export default HTTPCRC;
